import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import "./css/Gallery.css";

import ParticleBackground from "./ParticleBackground";
// import required modules
import { EffectCoverflow, Pagination } from "swiper";

const Gallery = () => {
  return (
    <div>
      <div id="gallerySection">
        <h1 style={{ fontFamily: "Bebas Neue" }}> BRAHMTAL TREK</h1>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={"images/brahmtal/brahmtal1.jpeg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/brahmtal/brahmtal2.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/brahmtal/brahmtal3.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/brahmtal/brahmtal4.jpg"} />
          </SwiperSlide>
        </Swiper>

        <div className="location">
          <h1 style={{ fontFamily: "Bebas Neue" }}> TRIUND - BIR BILLING</h1>
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={true}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            <SwiperSlide>
              <img src={"images/triund/triund1.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/triund/triund2.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/triund/triund3.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/triund/triund4.jpg"} />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="location">
          <h1 style={{ fontFamily: "Bebas Neue" }}> CHITKUL</h1>
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={true}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            <SwiperSlide>
              <img src={"images/chitkul/chitkul1.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/chitkul/chitkul2.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/chitkul/chitkul3.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/chitkul/chitkul4.jpg"} />
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="location">
          <h1 style={{ fontFamily: "Bebas Neue" }}> PARVATI VALLEY</h1>
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={true}
            modules={[EffectCoverflow, Pagination]}
            className="mySwiper"
          >
            <SwiperSlide>
              <img src={"images/parvati/parvati1.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/parvati/parvati2.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/parvati/parvati3.jpg"} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={"images/parvati/parvati4.jpg"} />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
